(function () {
  function getSearchParams() {
    return new URLSearchParams(window.location.search);
  }

  function getSearchQuery() {
    return (getSearchParams().get('q') || '').trim();
  }

  function buildSearchUrl(type, queryOverride) {
    var query = typeof queryOverride === 'string' ? queryOverride : getSearchQuery();
    var url = new URL(window.theme.routes.search_url, window.location.origin);

    if (query) {
      url.searchParams.set('q', query);
    }

    url.searchParams.set('type', type);
    url.searchParams.set('options[prefix]', 'last');

    return url.pathname + url.search;
  }

  function canonicalizeUntypedSearch(container) {
    if (!container || container.dataset.searchNeedsTypeRedirect !== 'true') {
      return false;
    }

    var params = getSearchParams();
    if (params.get('type')) {
      return false;
    }

    var nextUrl = buildSearchUrl('product');
    if (nextUrl !== window.location.pathname + window.location.search) {
      window.location.replace(nextUrl);
      return true;
    }

    return false;
  }

  function updateTabCount(type, count) {
    var countEl = document.querySelector('[data-search-tab-count="' + type + '"]');
    if (!countEl) {
      return;
    }

    countEl.textContent = '(' + count + ')';
  }

  function updateTabHref(type, query) {
    var tab = document.querySelector('[data-search-tab="' + type + '"]');
    if (!tab || !query) {
      return;
    }

    tab.setAttribute('href', buildSearchUrl(type, query));
  }

  function fetchSearchCount(query, type, sectionId) {
    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('q', query);
    url.searchParams.set('type', type);
    url.searchParams.set('options[prefix]', 'last');

    return fetch(url.toString())
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var partial = doc.querySelector('[data-partial]');
        return partial ? Number(partial.dataset.searchResultsCount || 0) : 0;
      });
  }

  function getSuggestResults(term) {
    var base = (window.theme && window.theme.routes && window.theme.routes.predictive_search_url) || '/search/suggest';
    var url = new URL(base, window.location.origin);

    if (!/\.json$/i.test(url.pathname)) {
      url.pathname += '.json';
    }

    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'query,product');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[limit_scope]', 'each');

    if (window.theme && window.theme.searchableFields) {
      url.searchParams.set('resources[options][fields]', window.theme.searchableFields);
    }

    return fetch(url.toString())
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Predictive search failed');
        }

        return response.json();
      })
      .then(function (data) {
        var resources = (data && data.resources) || {};
        return resources.results || resources;
      });
  }

  function firstMatchingWord(value, term) {
    if (!value || !term) {
      return '';
    }

    var needle = term.toLowerCase();
    var words = String(value).split(/[^a-zA-Z0-9]+/);

    for (var i = 0; i < words.length; i += 1) {
      var word = words[i];
      if (word && word.toLowerCase().indexOf(needle) === 0 && word.length > term.length) {
        return word;
      }
    }

    return '';
  }

  function pickExpandedProductQuery(term, results) {
    var queries = (results && results.queries) || [];
    var products = (results && results.products) || [];
    var i;

    for (i = 0; i < queries.length; i += 1) {
      var suggestion = firstMatchingWord(queries[i] && queries[i].text, term);
      if (suggestion) {
        return suggestion;
      }
    }

    for (i = 0; i < products.length; i += 1) {
      var titleMatch = firstMatchingWord(products[i] && products[i].title, term);
      if (titleMatch) {
        return titleMatch;
      }

      var typeMatch = firstMatchingWord(products[i] && products[i].type, term);
      if (typeMatch) {
        return typeMatch;
      }
    }

    return '';
  }

  function resolveExpandedProductQuery(term) {
    if (!term) {
      return Promise.resolve('');
    }

    return getSuggestResults(term)
      .then(function (results) {
        var expanded = pickExpandedProductQuery(term, results);
        if (!expanded || expanded.toLowerCase() === term.toLowerCase()) {
          return '';
        }

        return expanded;
      })
      .catch(function () {
        return '';
      });
  }

  function shouldExpandEmptyProductSearch(container) {
    if (!container || container.dataset.searchActiveType !== 'product') {
      return false;
    }

    if (Number(container.dataset.searchItemCount || 0) > 0) {
      return false;
    }

    return Boolean(getSearchQuery());
  }

  function setExpandingState(container, isExpanding) {
    if (!container) {
      return;
    }

    container.dataset.searchExpanding = isExpanding ? 'true' : 'false';

    var loader = container.querySelector('[data-loading]');
    if (!loader) {
      return;
    }

    loader.classList.toggle('is-active', isExpanding);
  }

  function expandEmptyProductSearch(container) {
    if (!shouldExpandEmptyProductSearch(container)) {
      return Promise.resolve(false);
    }

    setExpandingState(container, true);

    return resolveExpandedProductQuery(getSearchQuery()).then(function (expanded) {
      if (!expanded) {
        setExpandingState(container, false);
        return false;
      }

      window.location.replace(buildSearchUrl('product', expanded));
      return true;
    });
  }

  function fetchInactiveTabCount(container) {
    if (!container || !window.theme || !window.theme.routes) {
      return;
    }

    var activeType = container.dataset.searchActiveType || 'product';
    var inactiveType = activeType === 'product' ? 'article' : 'product';
    var sectionId = container.dataset.sectionId;
    var query = getSearchQuery();

    if (!sectionId || !query) {
      updateTabCount(inactiveType, 0);
      return;
    }

    fetchSearchCount(query, inactiveType, sectionId)
      .then(function (count) {
        if (inactiveType !== 'product' || count > 0) {
          updateTabCount(inactiveType, count);
          return;
        }

        return resolveExpandedProductQuery(query).then(function (expanded) {
          if (!expanded) {
            updateTabCount('product', 0);
            return;
          }

          updateTabHref('product', expanded);

          return fetchSearchCount(expanded, 'product', sectionId).then(function (expandedCount) {
            updateTabCount('product', expandedCount);
          });
        });
      })
      .catch(function () {
        updateTabCount(inactiveType, 0);
      });
  }

  function initCustomSearch() {
    var container = document.querySelector('[data-section-type="search"].custom-search');
    if (!container) {
      return;
    }

    if (canonicalizeUntypedSearch(container)) {
      return;
    }

    expandEmptyProductSearch(container).then(function (redirected) {
      if (redirected) {
        return;
      }

      fetchInactiveTabCount(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomSearch);
  } else {
    initCustomSearch();
  }
})();
